export const classes = [
  { 
    id: 1, 
    name: "High Intensity Shred", 
    time: "07:00 AM", 
    instructor: "Mike T.", 
    spots: 4, 
    duration: "45 min",
    calories: 600,
    image: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&q=80",
    category: "HIIT"
  },
  { 
    id: 2, 
    name: "Power Yoga Flow", 
    time: "09:00 AM", 
    instructor: "Sarah J.", 
    spots: 8, 
    duration: "60 min",
    calories: 350,
    image: "https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?auto=format&fit=crop&q=80",
    category: "Yoga"
  },
  { 
    id: 3, 
    name: "Spin Cycle Extreme", 
    time: "05:30 PM", 
    instructor: "Tom R.", 
    spots: 12, 
    duration: "45 min",
    calories: 500,
    image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&q=80",
    category: "Cycling"
  },
  { 
    id: 4, 
    name: "Boxing Fundamentals", 
    time: "06:00 PM", 
    instructor: "Alex K.", 
    spots: 2, 
    duration: "50 min",
    calories: 700,
    image: "https://images.unsplash.com/photo-1549719386-74dfcbf7dbed?auto=format&fit=crop&q=80",
    category: "Boxing"
  }
];

export const leaderboard = [
    { rank: 1, name: "Sarah Anderson", points: 2450, avatar: "SA" },
    { rank: 2, name: "John Doe", points: 2100, avatar: "JD" },
    { rank: 3, name: "Emily Blunt", points: 1950, avatar: "EB" },
    { rank: 4, name: "Mike Ross", points: 1800, avatar: "MR" },
];
